export default __webpack_public_path__ + "static/media/pin.89f26794.svg";